import axios from "axios";
import _ from "lodash";
import constants from "@/config/constants";

function initialState() {
    return { 
        loading: false,
        triviaTemp: false, 
        is_trivia_editing: false,
        is_new_question: false,
        datanum: null,
        questionstatus: true,
        sitems: {
            question_title: null,
            question_type: 'radio',
            require: true,
            answers: [
                { answer_title: null, description: null, is_correct: false, tempID: Date.now() }
            ]
        },
    }
}

const getters = {   
    sitems: state => state.sitems,       
    loading: state => state.loading,
    triviaTemp: state => state.triviaTemp,
    is_trivia_editing: state => state.is_trivia_editing,
    is_new_question: state => state.is_new_question,
    datanum: state => state.datanum,
    questionstatus: state => state.questionstatus,
}

const actions = {
    setAnswersOptions({ commit, state }, multidata) {
        let answerText = multidata.answerText;
        let answerId = multidata.answerId;
        const params = _.cloneDeep(state.sitems.answers);
        
        let index = params.findIndex(x => x.tempID === answerId || x._id === answerId);
        
        if (index !== -1) {
            params[index].answer_title = answerText;
            commit('setQItem', params);
        } else {
            console.warn('Answer not found with ID:', answerId);
        }
    },

    setCorrectAnswer({ commit, state }, answerId) {
        const params = _.cloneDeep(state.sitems.answers);
        params.forEach(answer => {
            answer.is_correct = (answer.tempID === answerId || answer._id === answerId);
        });
        commit('setQItem', params);
    },

    addAnswerOption({ commit, state }) {
        const params = _.cloneDeep(state.sitems.answers);
        params.push({
            answer_title: null,
            description: null,
            is_correct: false,
            tempID: Date.now() + Math.random()
        });
        commit('setQItem', params);
    },

    removeAnswerOption({ commit, state }, index) {
        const params = _.cloneDeep(state.sitems.answers);
        params.splice(index, 1);
        commit('setQItem', params);
    },

    storeQuestion({ commit, state, dispatch }, trivia_id) {
        commit('setLoading', true)
        
        const params = _.cloneDeep(state.sitems);
        
        delete params._id;
        delete params.tempID;
        
        // Filter out empty answers and remove tempID
        if (params.question_type === 'radio') {
            params.answers = params.answers
                .filter(answer => answer.answer_title && answer.answer_title.trim() !== '')
                .map(answer => {
                    const { tempID, ...cleanAnswer } = answer;
                    return cleanAnswer;
                });
        } else {
            // For textbox type, answers array might be empty or not needed
            delete params.answers;
        }
        
        const headers = {
            'Authorization': 'Bearer ' + localStorage.getItem('token')
        };   
       
        return axios.post(constants.API_URL + '/api/trivia/' + trivia_id + '/question', params, {headers: headers})
            .then(response => {
                commit('setTriviaTemp', true);
                commit('setIsNewQuestion', false);
                if (response.data.data && response.data.data.questions_detail) {
                    commit('setDataNum', response.data.data.questions_detail.length);
                }
                return response;
            })
            .finally(() => {
                commit('setLoading', false)
            })
    },

    async updateQuestion({ commit, state }, data) {
        commit('setLoading', true)
        
        let params = _.cloneDeep(state.sitems);
        
        // Filter out empty answers and remove tempID
        if (params.question_type === 'radio') {
            params.answers = params.answers
                .filter(answer => answer.answer_title && answer.answer_title.trim() !== '')
                .map(answer => {
                    const { tempID, ...cleanAnswer } = answer;
                    return cleanAnswer;
                });
        } else {
            delete params.answers;
        }
        
        const headers = {
            'Authorization': 'Bearer ' + localStorage.getItem('token')
        };
        
        return axios.patch(constants.API_URL + '/api/trivia/' + data.trivia_id + '/question/' + data.question_id, params, {headers: headers})       
            .then((response) => {
                commit('setIs_trivia_editing', false);
                if (response.data.data) {
                    let question_detail = response.data.data;
                    var questionsData = _.find(question_detail.questions_detail, {_id: data.question_id});
                    if (questionsData) {
                        commit('setItem', questionsData);
                    }
                }
                return response;
            })
            .finally(() => {
                commit('setLoading', false)
                commit('setTriviaTemp', true)
            })
    },

    async destroyQuestion({ commit, state }, data) {
        const headers = {
            'Authorization': 'Bearer ' + localStorage.getItem('token')
        };        

        return await axios.delete(constants.API_URL + '/api/trivia/' + data.trivia_id + '/question/' + data.question_id, {headers: headers})
            .then(response => {
                return response;
            }).finally(() => {
                commit('setLoading', false)
            })
    },

    setItem({ commit }, value) {
        commit('setItem', value)
    },
    
    setQItem({ commit }, value) {
        commit('setQItem', value)
    },
    
    setIs_trivia_editing({ commit }, value) {
        commit('setIs_trivia_editing', value)
    },
    
    setIsNewQuestion({ commit }, value) {
        commit('setIsNewQuestion', value)
    },
    
    setTriviaTemp({ commit }, value) {
        commit('setTriviaTemp', value)
    },
    
    setDataNum({ commit }, value) {
        commit('setDataNum', value)
    },
    
    setQuestionTitle({ commit }, value) {
        commit('setQuestionTitle', value)
    },
    
    setQuestionType({ commit }, value) {
        commit('setQuestionType', value)
    },
    
    setIsRequired({ commit }, value) {
        commit('setIsRequired', value)
    },
    
    resetState({ commit }) {
        commit('resetState')
    }
}

const mutations = {
    setItem(state, item) {
        state.sitems = { ...state.sitems, ...item }
    },
    
    setQItem(state, item) {
        state.sitems.answers = item
    },
    
    setQuestionTitle(state, value) {
        state.sitems.question_title = value
    },
    
    setQuestionType(state, value) {
        state.sitems.question_type = value
    },
    
    setIsRequired(state, value) {
        state.sitems.require = value
    },
    
    setTriviaTemp(state, value) {
        state.triviaTemp = value
    },
    
    setIs_trivia_editing(state, value) {
        state.is_trivia_editing = value
    },
    
    setIsNewQuestion(state, value) {
        state.is_new_question = value
    },
    
    setDataNum(state, value) {
        state.datanum = value
    },
    
    setLoading(state, loading) {
        state.loading = loading
    },
    
    resetState(state) {
        Object.assign(state, initialState())
    }
}

export default {
    namespaced: true,
    state: initialState,
    getters,
    actions,
    mutations
}